import { TaxonomyNavItemIcon } from '@modules/leftNavSidebar/components/icons';
import { TaxonomyBackfillDurationSelect } from '@modules/users/components/TaxonomyBackfillDurationSelect';
import { WorkspaceSettingsItem } from '@modules/workspaceSettings/components/WorkspaceSettingsItem';
import { Stack, Typography } from '@mui/material';

export const TaxonomySettings = () => {
  return (
    <WorkspaceSettingsItem
      icon={<TaxonomyNavItemIcon sx={{ color: 'text.secondary' }} />}
      title="Taxonomy Settings"
    >
      <Stack
        spacing={4}
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack spacing={1}>
          <Typography variant="body1">
            Backfill Duration for Taxonomy Edits
          </Typography>
          <Typography variant="body2" color="text.secondary">
            When you edit a prediction on a feedback, or make changes to your
            taxonomy, we'll backfill all feedback records to reflect the changes
            for the duration you set. By default, this is 3 months.
          </Typography>
        </Stack>
        <TaxonomyBackfillDurationSelect />
      </Stack>
    </WorkspaceSettingsItem>
  );
};
